import React from 'react';

import { BoxProps, Button, Card, Flex } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { ManageSmartAssistantSectionControlWrapper } from 'pages/ManageSmartAssistant/ManageSmartAssistantControlWrapper';
import { ToolsTable } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolsTable';
import { useTranslation } from 'react-i18next';
import { ToolConfig, ToolGroup } from 'shared/interfaces/tools/Tool';

interface ToolsOverviewProps extends BoxProps {
  attachedToolGroups: ToolGroup[];
  deleteToolConfigs: (toolConfigs: ToolConfig[]) => void;
  onAddTool: () => void;
}

export function ToolsOverview({ attachedToolGroups, deleteToolConfigs, onAddTool, ...boxProps }: ToolsOverviewProps) {
  const { t } = useTranslation();

  return (
    <ManageSmartAssistantSectionControlWrapper
      title={t('SMART_ASSISTANT.TOOLS_SECTION.TITLE')}
      withMarginBottom
      {...boxProps}>
      <Card withBorder>
        <Card.Section p="md">
          <ToolsTable toolGroups={attachedToolGroups} deleteToolConfigs={deleteToolConfigs} isLoading={false} />
        </Card.Section>

        <Card.Section withBorder inheritPadding py="md">
          <Flex justify="flex-end">
            <Button leftIcon={<IconPlus size={14} />} onClick={onAddTool}>
              {t('SMART_ASSISTANT.TOOLS_SECTION.ADD_TOOL_BUTTON')}
            </Button>
          </Flex>
        </Card.Section>
      </Card>
    </ManageSmartAssistantSectionControlWrapper>
  );
}
